<form [formGroup]="ccrForm" class="form-container row">
  <eps-text-input
    formControlName="sealNumber"
    class="col-12 field"
    label="ORDERS.FILTER.LABELS.SEAL_NUMBER"
    [labelWidth]="labelWidth"
  ></eps-text-input>

  <eps-label-body *ngIf="ccrForm.get('sealNumber').errors" label=" " [labelWidth]="labelWidth">
    <div class="error-message">{{ 'ORDERS.PLANNING.SEAL_NUMBER_EMPTY' | translate }}</div>
  </eps-label-body>
  <div>&nbsp;</div>
  <div class="hr"></div>
  <eps-date-input
    label="ORDERS.FILTER.LABELS.ORDER_DATE"
    formControlName="orderDate"
    class="col-12 field"
    [labelWidth]="labelWidth"
    [readonly]="!panelStatus.isEdit"
    [disabled]="!panelStatus.isEdit && panelStatus.isEditable"
    *ngIf="!panelStatus.isEdit"
  ></eps-date-input>
  <!-- LOADING DATE : date -->
  <eps-date-input
    label="ORDERS.DETAIL.LABELS.LOADING_DATE"
    formControlName="loadingDate"
    class="col-12 field"
    [labelWidth]="labelWidth"
    [readonly]="!panelStatus.isEdit"
    [disabled]="!panelStatus.isEdit && panelStatus.isEditable"
    [validRanges]='availablePickingDates'
    *ngIf="!panelStatus.isEdit"
  ></eps-date-input>

  <!-- exchange pallets -->
  <eps-checkbox
    label="ORDERS.DETAIL.LABELS.EXCHANGE_PALLETS"
    formControlName="exchangePallets"
    class="col-12 field"
    [labelWidth]="labelWidth"
    [readonly]="!panelStatus.isEdit"
    [useIconsInReadonly]="true"
    [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
  ></eps-checkbox>

  <eps-number-input
    label="ORDERS.DETAIL.LABELS.NUMBER_OF_EXCHANGE_PALLETS"
    formControlName="numberOfExchangePallets"
    class="col-12 field"
    max="10000"
    [labelWidth]="labelWidth"
    [readonly]="!panelStatus.isEdit"
    *ngIf="ccrForm.value.exchangePallets"
  ></eps-number-input>
</form>
